import { render, staticRenderFns } from "./CreateDeliverable.vue?vue&type=template&id=32a89cde&scoped=true&"
import script from "./CreateDeliverable.vue?vue&type=script&lang=js&"
export * from "./CreateDeliverable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a89cde",
  null
  
)

export default component.exports